/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TeilDatumSearchRequest } from './teilDatumSearchRequest';
import { CapiCodeId } from './capiCodeId';
import { HistorySearchOptions } from './historySearchOptions';
import { ElasticSearchOptions } from './elasticSearchOptions';


export interface PersonGbSearchErweitertRequest { 
    personStammVersionArt?: PersonGbSearchErweitertRequest.PersonStammVersionArtEnum;
    name?: string;
    vorname?: string;
    ledigname?: string;
    geburtsdatum?: TeilDatumSearchRequest;
    sitz?: string;
    uid?: string;
    ahvNummer?: string;
    ahvVersichertennummer?: string;
    historySearchOptions?: HistorySearchOptions;
    strasse?: string;
    hausnummer?: string;
    plz?: string;
    ort?: string;
    rolle?: PersonGbSearchErweitertRequest.RolleEnum;
    rolleEigentuemer?: boolean;
    rolleUebrigeBerechtigeDienstbarkeit?: boolean;
    rolleUebrigeBerechtigeGrundlast?: boolean;
    rolleUebrigeBerechtigeAnmerkung?: boolean;
    rolleUebrigeBerechtigeVormerkung?: boolean;
    rolleGlaeubiger?: boolean;
    rolleSchuldner?: boolean;
    glaeubigerrolle?: PersonGbSearchErweitertRequest.GlaeubigerrolleEnum;
    codeGlaeubiger?: CapiCodeId;
    codeSchuldner?: CapiCodeId;
    isSearchEigentuemerEnabled?: boolean;
    isSearchUebrigeBerechtigteEnabled?: boolean;
    isSearchGlaeubigerSchuldnerEnabled?: boolean;
    mPersonStammVersionArtList?: Array<PersonGbSearchErweitertRequest.MPersonStammVersionArtListEnum>;
    mGlaeubigerrolleList?: Array<PersonGbSearchErweitertRequest.MGlaeubigerrolleListEnum>;
    personStammSort?: PersonGbSearchErweitertRequest.PersonStammSortEnum;
    sortDirection?: PersonGbSearchErweitertRequest.SortDirectionEnum;
    elasticSearchOptions?: ElasticSearchOptions;
}
export namespace PersonGbSearchErweitertRequest {
    export type PersonStammVersionArtEnum = 'NATUERLICHE_PERSON' | 'SCHWEIZERISCHE_JURISTISCHE_PERSON' | 'OEFFENTLICHE_KOERPERSCHAFT' | 'AUSLAENDISCHE_RECHTSFORM';
    export const PersonStammVersionArtEnum = {
        NATUERLICHEPERSON: 'NATUERLICHE_PERSON' as PersonStammVersionArtEnum,
        SCHWEIZERISCHEJURISTISCHEPERSON: 'SCHWEIZERISCHE_JURISTISCHE_PERSON' as PersonStammVersionArtEnum,
        OEFFENTLICHEKOERPERSCHAFT: 'OEFFENTLICHE_KOERPERSCHAFT' as PersonStammVersionArtEnum,
        AUSLAENDISCHERECHTSFORM: 'AUSLAENDISCHE_RECHTSFORM' as PersonStammVersionArtEnum
    };
    export type RolleEnum = 'EIGENTUEMER' | 'UEBRIGE_BERECHTIGTE' | 'GLAEUBIGER_SCHULDNER' | 'ALLE';
    export const RolleEnum = {
        EIGENTUEMER: 'EIGENTUEMER' as RolleEnum,
        UEBRIGEBERECHTIGTE: 'UEBRIGE_BERECHTIGTE' as RolleEnum,
        GLAEUBIGERSCHULDNER: 'GLAEUBIGER_SCHULDNER' as RolleEnum,
        ALLE: 'ALLE' as RolleEnum
    };
    export type GlaeubigerrolleEnum = 'GRUNDPFANDGLAEUBIGER' | 'FAUSTPFANDGLAEUBIGER' | 'NUTZNIESSER' | 'ANDEREROLLE';
    export const GlaeubigerrolleEnum = {
        GRUNDPFANDGLAEUBIGER: 'GRUNDPFANDGLAEUBIGER' as GlaeubigerrolleEnum,
        FAUSTPFANDGLAEUBIGER: 'FAUSTPFANDGLAEUBIGER' as GlaeubigerrolleEnum,
        NUTZNIESSER: 'NUTZNIESSER' as GlaeubigerrolleEnum,
        ANDEREROLLE: 'ANDEREROLLE' as GlaeubigerrolleEnum
    };
    export type MPersonStammVersionArtListEnum = 'NATUERLICHE_PERSON' | 'SCHWEIZERISCHE_JURISTISCHE_PERSON' | 'OEFFENTLICHE_KOERPERSCHAFT' | 'AUSLAENDISCHE_RECHTSFORM';
    export const MPersonStammVersionArtListEnum = {
        NATUERLICHEPERSON: 'NATUERLICHE_PERSON' as MPersonStammVersionArtListEnum,
        SCHWEIZERISCHEJURISTISCHEPERSON: 'SCHWEIZERISCHE_JURISTISCHE_PERSON' as MPersonStammVersionArtListEnum,
        OEFFENTLICHEKOERPERSCHAFT: 'OEFFENTLICHE_KOERPERSCHAFT' as MPersonStammVersionArtListEnum,
        AUSLAENDISCHERECHTSFORM: 'AUSLAENDISCHE_RECHTSFORM' as MPersonStammVersionArtListEnum
    };
    export type MGlaeubigerrolleListEnum = 'GRUNDPFANDGLAEUBIGER' | 'FAUSTPFANDGLAEUBIGER' | 'NUTZNIESSER' | 'ANDEREROLLE';
    export const MGlaeubigerrolleListEnum = {
        GRUNDPFANDGLAEUBIGER: 'GRUNDPFANDGLAEUBIGER' as MGlaeubigerrolleListEnum,
        FAUSTPFANDGLAEUBIGER: 'FAUSTPFANDGLAEUBIGER' as MGlaeubigerrolleListEnum,
        NUTZNIESSER: 'NUTZNIESSER' as MGlaeubigerrolleListEnum,
        ANDEREROLLE: 'ANDEREROLLE' as MGlaeubigerrolleListEnum
    };
    export type PersonStammSortEnum = 'BEZEICHNUNG' | 'ART';
    export const PersonStammSortEnum = {
        BEZEICHNUNG: 'BEZEICHNUNG' as PersonStammSortEnum,
        ART: 'ART' as PersonStammSortEnum
    };
    export type SortDirectionEnum = 'ASC' | 'DESC';
    export const SortDirectionEnum = {
        ASC: 'ASC' as SortDirectionEnum,
        DESC: 'DESC' as SortDirectionEnum
    };
}


